/**
 * Created by Claude on 29.01.2026
 */

class KingsCupMissionWindowController extends ScriptComponent {
    onCreate() {
        this.bus = new cleverapps.EventEmitter();

        this.mission = this.options.mission;
        this.closeWindowCallback = this.options.closeWindowCallback;

        this.mission.logEvent(Mission.EVENTS.MISSION_WINDOW);
        this.mission.logEvent(Mission.EVENTS.MISSION_WINDOW_DAU, { once: true });
    }

    getMission() {
        return this.mission;
    }

    getType() {
        return this.mission.type;
    }

    isRunning() {
        return this.mission.isRunning();
    }

    getTimeLeft() {
        return this.mission.getTimeLeft();
    }

    getName() {
        return this.mission.getName();
    }

    getTable() {
        return this.mission.runningCompetition.table;
    }

    getPrize() {
        return this.mission.getPrize();
    }

    onShow() {
        this.mission.runningCompetition.table.showUp();

        this.bus.trigger("show");
    }

    onHide() {
        this.bus.trigger("hide");
    }

    onClose() {
        this.mission.runningCompetition.updateShownPlace();
        this.mission.updateMissionIcon();
    }

    onDestroy() {
    }
}
